export const AI_NO_ACTIVE_PROVIDER_KEY_CODE = 210;

const AI_KEYWORD_RESEARCH_WARNING_MESSAGES: Record<number, string> = {
  209: 'اعتبار AI شما کافی نیست. لطفا پس از شارژ اعتبار، دوباره تلاش کنید.',
  [AI_NO_ACTIVE_PROVIDER_KEY_CODE]:
    'کلید API شخصی ثبت نشده یا هیچ کلید فعالی ندارید. برای ثبت یا فعال‌سازی کلید به تنظیمات AI بروید. همچنین می‌توانید با انتخاب «AI خودکار (کیف پول)» در تنظیمات، از اعتبار کیف پول AI برای ارسال درخواست استفاده کنید.',
  212: 'API Key شما معتبر نیست.',
  217:
    'سهمیه یا محدودیت نرخ درخواست API شما به پایان رسیده است. لطفاً کمی بعد دوباره تلاش کنید یا پلن/صورتحساب ارائه‌دهنده (مثل Google AI) را بررسی کنید.'
};

export const getAiWarningMessage = (
  code?: number | null
): string | null => {
  if (typeof code !== 'number') return null;
  return AI_KEYWORD_RESEARCH_WARNING_MESSAGES[code] || null;
};

/** Message for danger Alert under AI forms when API body code is not 200. */
export const resolveAiFormAlertMessage = (
  code?: number | null,
  msg?: string | null,
  fallback = 'در ارتباط با سرویس AI خطایی رخ داد.'
): string => {
  return (
    getAiWarningMessage(code) ||
    (typeof msg === 'string' && msg.trim() ? msg.trim() : null) ||
    fallback
  );
};

export default AI_KEYWORD_RESEARCH_WARNING_MESSAGES;
